import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {LinkWithAttribution} from '../../../../components';

export function HighLDLCholesterol() {
    const intl = useIntl();

    return (
        <>
            <div className={'heading is-caption is-heavy'}>
                <FormattedMessage id={'reports.trait.learnMoreAbout.common.heading'} />
            </div>
            <h4>
                <FormattedMessage id={'common.trait.HCH.title'} />
            </h4>
            <p>
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.paragraph.one'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.paragraph.two'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.paragraph.three'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.paragraph.four'} />
            </p>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.CDCP'})}
                url={'https://www.cdc.gov/cholesterol/about.htm'}
            >
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.link.one'} />
            </LinkWithAttribution>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.AHA'})}
                url={'https://www.heart.org/en/healthy-living/healthy-lifestyle/lifes-essential-8'}
            >
                <FormattedMessage id={'reports.trait.learnMoreAbout.HCH.link.two'} />
            </LinkWithAttribution>
        </>
    );
}
